/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoTheming {
    angular.module("meevo.plugins.meevoTheming", []);
}